import { ContentWithSidebar } from '@components/ContentWithSidebar';
import { PageTitle } from '@components/PageTitle';
import React, { Fragment } from 'react';
import { DateDivider } from './components/DateDivider';
import dayjs from 'dayjs';
import { ShiftCollection } from './components/ShiftCollection';
import { Shift } from './components/Shift';
import { YourShiftsSidebarPanel } from '../sideBarPanels/YourShiftsSidebarPanel';
import { OpenShiftsSidebarPanel } from '../sideBarPanels/OpenShiftsSidebarPanel';
import { UpcomingEventsPanel } from '../sideBarPanels/UpcomingEventsPanel';
import { HelpSidebarPanel } from '../sideBarPanels/HelpSidebarPanel';

export const DutyScheduleOverview: React.FC = (): JSX.Element => {
  const daysToShow = 14; // e.g. two weeks ahead
  const startDate = dayjs();

  const SidePanel = (
    <Fragment>
      <YourShiftsSidebarPanel />
      <OpenShiftsSidebarPanel />
      <UpcomingEventsPanel />
      <HelpSidebarPanel />
    </Fragment>
  );

  return (
    <Fragment>
      <PageTitle
        title="Inzetrooster"
        subTitle="Schrijf je in voor diensten en help mee"
      />
      <ContentWithSidebar wrapContentInPanel={false} sidebarContent={SidePanel}>
        {Array.from({ length: daysToShow }).map((_, index) => {
          const date = startDate.add(index, 'day');

          return (
            <div key={date.format('YYYY-MM-DD')}>
              <DateDivider
                date={date}
                sx={{
                  mt: index > 0 ? '25px' : '',
                }}
              />

              <ShiftCollection>
                <Shift
                  name="Bar"
                  from={date.set('hour', 9).set('minute', 0)}
                  to={date.set('hour', 13).set('minute', 0)}
                  color="#16a085"
                />

                <Shift
                  name="Bestuur"
                  from={date.set('hour', 9).set('minute', 0)}
                  to={date.set('hour', 13).set('minute', 0)}
                  color="#8e44ad"
                />

                <Shift
                  name="VVF (veiligheid)"
                  from={date.set('hour', 9).set('minute', 0)}
                  to={date.set('hour', 13).set('minute', 0)}
                  color="#3498db"
                  assignedMember={{
                    slug: 'esperanza-ankunding',
                    name: 'Eula Morissette',
                  }}
                />

                <Shift
                  name="VVH (wapenuitgifte)"
                  from={date.set('hour', 9).set('minute', 0)}
                  to={date.set('hour', 13).set('minute', 0)}
                  color="#c0392b"
                  locked
                  lockedInfo="Vereist certificaat"
                />

                {index === 3 && (
                  <ShiftCollection title="Clubwedstrijd" color="#d35400">
                    <Shift
                      name="Bar"
                      from={date.set('hour', 19).set('minute', 0)}
                      to={date.set('hour', 22).set('minute', 0)}
                      color="#16a085"
                    />
                    <Shift
                      name="Meyton"
                      from={date.set('hour', 19).set('minute', 0)}
                      to={date.set('hour', 22).set('minute', 0)}
                      color="#f1c40f"
                    />
                    <Shift
                      name="Meyton"
                      from={date.set('hour', 19).set('minute', 0)}
                      to={date.set('hour', 22).set('minute', 0)}
                      color="#f1c40f"
                    />
                  </ShiftCollection>
                )}
              </ShiftCollection>
            </div>
          );
        })}
      </ContentWithSidebar>
    </Fragment>
  );
};
